import logo from './logo.svg';
import './App.css';
import Login from './Components/Login';
import Module1 from './Components/Module1';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link,useParams } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
/*import "../node_modules/noty/lib/noty.css";  
import "../node_modules/noty/lib/themes/mint.css";  */
import Home from './Components/Home';
//import Merier from './Components/Design/Ecommerce/Merier';
// import Ehome from './Components/Design/Onky/Ehome';
// import Ehomeaboutus from './Components/Design/Onky/Ehomeaboutus';
// import Ehomecontactus from './Components/Design/Onky/Ehomecontactus';
// import Ehomeheader from './Components/Design/Onky/Ehomeheader';
// import Ehomefooter from './Components/Design/Onky/Ehomefooter';
// import Ehomecollection from './Components/Design/Onky/Ehomecollection';
// import Ehomesingle from './Components/Design/Onky/Ehomesingle';
import About from './Components/About';
import Overview from './Components/Overview';
import Sidebar from './Components/Sidebar';
import ForgotPassword from './Components/ForgotPassword';
import RecoverPassword from './Components/RecoverPassword';
import Dashboard from './Components/Dashboard';
import Form1 from './Examples/Form1';
import UserRole from './Components/UserRole';
import MenuMaster from './Components/MenuMaster';
import RoleMenu from './Components/RoleMenu';
import UserActivation from './Components/UserActivation';
import DropDownMaster from './Components/DropDownMaster';
import Studentcalendar from './Components/Studentcalendar';
import Staffcalendar from './Components/Staffcalendar'; 
import Userc from './Components/Userc';
import Invoice from './Components/Invoice';
import Enquirysuccess from './Components/Enquirysuccess';
import Invoicepayment from './Components/Invoicepayment';
import ChangePassword from './Components/ChangePassword';
import ExcelUpload from './Components/ExcelUpload';
import ExceptionReport from './Components/ExceptionReport.js'
import StoreExcelUpload from './Components/StoreExcelUpload.js';





class App extends React.Component
{
    // state = { view_count: 0 , view: 'settings'}
    state = { view_count: 0 , view: 'login',enquiryid:0,enquiryreference:'',qdnid:0,qdnno:'',qdnstatus:'',invadmissionrowid:0,cpwduserd:'',cpwdusername:''}
    constructor(props) {
      super(props);     
    }
    refreshEnquiryCallback=(cmp,enquiry_id,enqreference)=>{
      //gbconsole.log('enquiry---id=',enquiry_id)
      if(cmp=="logout"){
        this.logout()
       }
       else
       {
         if(cmp!='')
         this.setState({view_count : this.state.view_count + 1, view: cmp,enquiryid:enquiry_id,enquiryreference:enqreference})
       }
    }
   refreshStateEnquiry=(cmp,enquiry_id,enqreference)=>{
     //gbconsole.log('enquiry---id=',enquiry_id)
    if(cmp=="logout"){
      this.logout()
     }
     else
     {
       if(cmp!='')
       this.setState({view_count : this.state.view_count + 1, view: cmp,enquiryid:enquiry_id,enquiryreference:enqreference})
     }
   }

   refreshStateQdn=(cmp,qdnid,qdnno)=>{
    console.log('cmp=',cmp);
    console.log('qdn---id=',qdnid)
    console.log('qdnno=',qdnno)
   if(cmp=="logout"){
     this.logout()
    }
    else
    {
      if(cmp!=''){
        const postdata={

         
          "qdnno":qdnno
         
        };
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' ,'Authorization': 'Bearer '+ localStorage.getItem('UserToken')},
          body:JSON.stringify(postdata)
      };
      let url='http://localhost/scm/api/getqdndetails';
      url=process.env.REACT_APP_DEBUG_URL+'/api/getqdndetails';
      fetch(url, requestOptions).then(response => response.json()).then(data => { 
        var qdnstatus=data.Message;
        console.log('qdnstatus=',data.Message);
        this.setState({view_count : this.state.view_count + 1, view: cmp,qdnid:qdnid,qdnno:qdnno,qdnstatus:qdnstatus})
       
    }
        
        
        );
      
       
      }
     
    }
  }

    refreshState = (cmp) => {
      console.log(cmp)
      if(cmp=="logout"){
       this.logout()
      }
      else
      {
        if(cmp!='')
        this.setState({view_count : this.state.view_count + 1, view: cmp})
      }
      
      // //gbconsole.log(cmp);
      // this.setState({view: cmp})
    }

    refreshUserState = (cmp,userid,username) => {
      console.log(cmp)
      if(cmp=="logout"){
       this.logout()
      }
      else
      {
        if(cmp!='')
        this.setState({view_count : this.state.view_count + 1, view: cmp,cpwduserd:userid,cpwdusername:username})
      }
      
      // //gbconsole.log(cmp);
      // this.setState({view: cmp})
    }

    refreshInvoiceState = (cmp,rowid) => {
      if(cmp=="logout"){
       this.logout()
      }
      else
      {
        if(cmp!='')
        this.setState({view_count : this.state.view_count + 1,invadmissionrowid:rowid},()=>{this.setState({view: cmp})})
      }
      
      // //gbconsole.log(cmp);
      // this.setState({view: cmp})
    }

    componentDidMount() { 
    
    }   

     CurrentTimeStamp=()=>{
      let date=new Date();      
      let bidtimestamp=date.toLocaleString();
      var seconds = date.getSeconds();
      var minutes = date.getMinutes();
      var hour = date.getHours();
      var year = date.getFullYear();
      var month = date.getMonth(); // beware: January = 0; February = 1, etc.
      month = month + 1;
      var day = date.getDate();
      bidtimestamp ='' + day + '/' + month + '/' + year + ', ' + hour + ':' + minutes + ':' + seconds;
     
     return bidtimestamp ;
    }
    

    logout= () =>{
    
   
//gbconsole.log('logout')
  const postlogout={

    "LoginId":localStorage.getItem('LoginID'),
    "branchID":0,
    "TimeStamp":this.CurrentTimeStamp()
   
  };
  //gbconsole.log(postlogout)

  const requestOptions1 = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' ,'Authorization': 'Bearer '+ localStorage.getItem('UserToken')},
          body:JSON.stringify(postlogout)
      };
	  let url='http://localhost/scm/api/logout';
 url=process.env.REACT_APP_DEBUG_URL+'/api/logout';
      fetch(url, requestOptions1)
      .then(response => response.json())
      .then(data => { 
        alert(data.message)
         this.setState({view_count : this.state.view_count + 1, view: "login"});
       
    }
        
        
        );

      return 

}

    render() {
      //gbconsole.log(this.state.view);
     // const Ehome=React.lazy(()=>import ('./Components/Design/Onky/Ehome'))
return(
 
<Router>
<Switch>
          <Route path="/about" component={About} />
          {/* <Route path="/ehome" component={Ehome} /> */}
          {/* <Route path="/ehomeaboutus" component={Ehomeaboutus} refreshCallback={this.refreshState}/>
          <Route path="/ehomecontactus" component={Ehomecontactus} refreshCallback={this.refreshState} /> */}
          
          
          {/* <Route path="/ehome">
          <Ehomeheader currentlink='home' /><Ehome  /><Ehomefooter />

            </Route>
            <Route path="/ehomeaboutus">
            <Ehomeheader currentlink='about'/><Ehomeaboutus  /><Ehomefooter />

            </Route>

            <Route path="/ehomecontactus">
            <Ehomeheader currentlink='contact'/><Ehomecontactus  /><Ehomefooter />

            </Route>

            <Route path="/ehomecollection">
            <Ehomeheader currentlink='collection'/><Ehomecollection  /><Ehomefooter />

            </Route>

            <Route path="/ehomesingle">
            <Ehomeheader currentlink='single'/><Ehomesingle  /><Ehomefooter />

            </Route> */}

          <Route path="/studentadmission">
          <DropDownMaster tablename={'Admission master'} columnstoview={['First Name','Middle Name','Last Name','Fathers name','Course','Phone No']} showlist={'no'} />

            </Route>
            <Route path="/admission">
          <DropDownMaster tablename={'AdmissionTYI'} tablecaption={'Admission Master'} refreshInvoiceCallback={this.refreshInvoiceState} columnstoview={['Course','Session','First Name','Middle Name','Last Name','Mobile No']} showlist={'no'} />
         {
          (() => {
            switch(this.state.view) {

              case 'invoice': return  <Router><Invoice admissionid={this.state.invadmissionrowid}/></Router>; break;
              default: 
            }
            
          
        })()
           }
            </Route>
            <Route path='/enquiry'>
            <DropDownMaster tablename={'Enquiry Master'} tablecaption={'Enquiry Details'} refreshEnquiry={this.refreshEnquiryCallback}   showlist={'no'} />
            {
          (() => {
            switch(this.state.view) {

              case 'enqcallback': return  <Router><Enquirysuccess enqreferencenumber={this.state.enquiryreference}/></Router>; break;
              default: 
            }
            
          
        })()
           }
            </Route>
          <Route path="/invoice">
          <Invoice />
           </Route>
          <Route path="/">
           
         



        {/* return ( */}
          <div className="testdiv" style={{width:'100%',height:'100%'}}>


          
           
            {
              


              (() => {
                
                switch(this.state.view) {

                  case 'login' : return <Login refreshCallback={this.refreshState} />; break;
                  case 'home': return  <Router><Sidebar  currentLink={'home'} refreshCallback={this.refreshState} /><Home/></Router>; break;
                  case 'forgotpassword': return  <Router><ForgotPassword refreshCallback={this.refreshState} /></Router>; break;
                  case 'recoverpassword': return  <Router><RecoverPassword refreshCallback={this.refreshState} /></Router>; break;
                  case 'roleassigned' : return <Router><Sidebar  currentLink={'roleassigned'} refreshCallback={this.refreshState} /><UserRole/></Router>; break;
                  case 'menumaster' : return <Router><Sidebar currentLink={'menumaster'} refreshCallback={this.refreshState} /><MenuMaster/></Router>; break;
                  case 'rolemenu' : return <Router><Sidebar currentLink={'rolemenu'} refreshCallback={this.refreshState} /><RoleMenu/></Router>; break;
                  case 'role' : return <Router><Sidebar currentLink={'role'} refreshCallback={this.refreshState} /><Form1/></Router>; break;
                  case 'useractivation' : return <Router><Sidebar currentLink={'useractivation'} refreshCallback={this.refreshState} /><UserActivation  refreshCallback={this.refreshUserState}/></Router>; break;
                  case 'createstore':return  <Router><Sidebar currentLink={'createstore'} refreshCallback={this.refreshState} /><Userc title={'Create Store'} userrole={22}/></Router>; break;
                  case 'createaom':return  <Router><Sidebar currentLink={'createaom'} refreshCallback={this.refreshState} /><Userc title={'Create AOM'} userrole={25}/></Router>; break;
                  case 'createtm':return  <Router><Sidebar currentLink={'createtm'} refreshCallback={this.refreshState} /><Userc title={'Create TM'} userrole={26}/></Router>; break;
                  case 'creatersm':return  <Router><Sidebar currentLink={'creatersm'} refreshCallback={this.refreshState} /><Userc title={'Create RSM'} userrole={27}/></Router>; break;
                  case 'createhead':return  <Router><Sidebar currentLink={'createhead'} refreshCallback={this.refreshState} /><Userc title={'Create Head'} userrole={21}/></Router>; break;
                  case 'changepassword': return  <Router><Sidebar currentLink={'changepassword'} refreshCallback={this.refreshState} /><ChangePassword/></Router>; break; 
                  case 'changepassword2': return  <Router><Sidebar currentLink={'changepassword'} refreshCallback={this.refreshState} /><ChangePassword cpwduserid={this.state.cpwduserd} cpwdusername={this.state.cpwdusername}/></Router>; break;
                  case 'excelupload':return  <Router><Sidebar currentLink={'excelupload'}  refreshCallback={this.refreshState} /><ExcelUpload  /></Router>; break;
                  case 'city':return  <Router><Sidebar currentLink={'city'}  refreshCallback={this.refreshState} /><DropDownMaster formheader={'City Master'}  refreshCallback={this.refreshState}      tablename={'City'}    /></Router>; break;
                  case 'state':return  <Router><Sidebar currentLink={'state'}  refreshCallback={this.refreshState} /><DropDownMaster formheader={'State Master'}  refreshCallback={this.refreshState} columnstoview={['Zone','State','Description']}     tablename={'State'}    /></Router>; break;
                  case 'zone':return  <Router><Sidebar currentLink={'zone'}  refreshCallback={this.refreshState} /><DropDownMaster formheader={'Zone Master'}  refreshCallback={this.refreshState}      tablename={'Zone'}    /></Router>; break;
                  case 'agent':return  <Router><Sidebar currentLink={'agent'}  refreshCallback={this.refreshState} /><DropDownMaster formheader={'Agent/Format Master'}  refreshCallback={this.refreshState}      tablename={'Agent'}    /></Router>; break; 
                  case 'seasonimage':return  <Router><Sidebar currentLink={'seasonimage'}  refreshCallback={this.refreshState} /><DropDownMaster formheader={'Season Image Master'} role={'store'}  refreshCallback={this.refreshState}      tablename={'ImageMaster'}    /></Router>; break;
                  case 'seasonimageadmin':return  <Router><Sidebar currentLink={'seasonimageadmin'}  refreshCallback={this.refreshState} /><DropDownMaster showeditbutton={false}  role={'admin'}formheader={'Storewise Image Master'} columnstoview={['Format','Zone','State','City','TM','Aom','WeekNo','Store','Image']} refreshCallback={this.refreshState}      tablename={'ImageMaster'}    /></Router>; break;
                  case 'exceptionreport':return  <Router><Sidebar currentLink={'exceptionreport'}  refreshCallback={this.refreshState} /><ExceptionReport/> </Router>; break;
                  case 'storesupload':return  <Router><Sidebar currentLink={'storesupload'}  refreshCallback={this.refreshState} /><StoreExcelUpload refreshCallback={this.refreshState}  /></Router>; break;

                  default: 
                  
                  
                  return <div></div>;
                }
              })()
            }
          </div>
        {/* ); */}

        </Route>
        
         
          
        </Switch>
  </Router>
);
  }
}

export default App;

